import styled from "styled-components";
import { useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import CustomButton from "../../../helperComponents/CustomButton";
import MiniProfileCard from "../MiniProfileCard";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 35vw;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  width: 100%;
  gap: 20px;
  border-radius: 20px;
  background-color: var(--surface2);
  border: 1px solid var(--border);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

let dropDownStyle = { flex: 1 };

export default function AddOrEditCommentModular({
  itemID,
  userID,
  purpose,
  loading,
  setLoading,
  callback,
}) {
  const [item, setItem] = useState({});

  useEffect(() => {
    if (purpose == "UPDATE") {
      setLoading(true);
      if (itemID) {
        loadItemToBeEdited();
      }
    }
  }, [itemID, purpose]);

  if (loading) {
    return <LoadingSection />;
  }

  return (
    <PermissionGuard
      permissionName={"commentPermissions"}
      action={purpose == "ADD" ? "CREATE" : "UPDATE"}
    >
      <Container>
        <Inputs>
          <InputItems>
            <MaterialInput
              label={"Comment"}
              value={item.text}
              onChange={updateField("text")}
              multiline={true}
              rows={2}
            />
          </InputItems>
          <br />
          <Buttons>
            <CustomButton style={{ padding: "15px 40px" }} onClick={save}>
              {purpose == "UPDATE" ? "Sauvegarder" : "Ajouter"}
            </CustomButton>
          </Buttons>
        </Inputs>
      </Container>
    </PermissionGuard>
  );

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      let newItem = { ...item };
      if (dontUseEventValue) {
        newItem[fieldName] = e;
      } else {
        newItem[fieldName] = e.target.value;
      }

      setItem(newItem);
    };
  }

  function save() {
    if (purpose == "UPDATE") editItem();
    if (purpose == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/comment/?itemID=${itemID}`);
    setItem(data);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/comment", {
        text: item.text,
        subjectID: userID,
      });

      callback(res);
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/comment", {
        itemID,
        changes: {
          text: item.text,
        },
      });

      callback(res);
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
